export default __webpack_public_path__ + "static/media/dead5.07bc6315.gif";